import { tap } from "rxjs/operators";
import { HttpClientService } from "./http-client.service";
import { Observable, of } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable()
export class VideoVerificationSessionsService {
  constructor(private http: HttpClientService) {}

  // # GET /api/video_verification_sessions/:token
  public getMeetingInfo(token: string): Observable<any> {
    return this.http
      .get(`/api/video_verification_sessions/${token}`)
      .pipe(tap((_) => console.log("VideoVerificationSessionsService.getMeetingInfo: Ok.")));
  }

  // # PUT /api/video_verification_sessions/:token/update_call_status
  public updateCallStatus(token: string, started_at: Date | string, ended_at: Date | string): Observable<any> {
    let options = { started_at, ended_at };
    return this.http
      .put(`/api/video_verification_sessions/${token}/update_call_status`, options)
      .pipe(tap((_) => console.log("VideoVerificationSessionsService.updateCallStatus: Ok.")));
  }

  // # PUT /api/video_verification_sessions/:token/send_meeting
  public sendMeeting(token: string): Observable<any> {
    return this.http
      .put(`/api/video_verification_sessions/${token}/send_meeting`, {})
      .pipe(tap((_) => console.log("VideoVerificationSessionsService.sendMeeting: Ok.")));
  }

  // # PUT /api/video_verification_sessions/:token/schedule_call
  public scheduleCall(token: string, scheduled_at: Date | string): Observable<any> {
    let options = { scheduled_at };
    return this.http
      .put(`/api/video_verification_sessions/${token}/schedule_call`, options)
      .pipe(tap((_) => console.log("VideoVerificationSessionsService.scheduleCall: Ok.")));
  }

  // # PUT /api/video_verification_sessions/:token/register_attempt
  public registerAttempt(
    token: string,
    user: "analyst" | "client",
    location: any = { latitude: null, longitude: null },
    answered: boolean = true
  ): Observable<any> {
    let options = { user, location, answered };
    return this.http
      .put(`/api/video_verification_sessions/${token}/register_attempt`, options)
      .pipe(tap((_) => console.log("VideoVerificationSessionsService.registerAttempt: Ok.")));
  }

  // # PUT /api/video_verification_sessions/:token/submit_answers
  public submitAnswers(token: string, questions = []): Observable<any> {
    let options = { questions };
    return this.http
      .put(`/api/video_verification_sessions/${token}/submit_answers`, options)
      .pipe(tap((_) => console.log("VideoVerificationSessionsService.submitAnswers: Ok.")));
  }

  // # GET /api/video_verification_sessions/:token/geolocation_info
  public getGeolocationInfo(token: string): Observable<any> {
    return this.http
      .get(`/api/video_verification_sessions/${token}/geolocation_info`)
      .pipe(tap((_) => console.log("VideoVerificationSessionsService.getGeolocationInfo: Ok.")));
  }
}
